import { useEffect } from 'react'
import { AdminPanelPage } from '../AdminPanelPage'
import { BreadcrumbProps, NumberDisplay } from '@aidkitorg/component-library'
import { useLocalizedStrings } from '../../Localization'
import { MyReviewsDataTable } from './components/MyReviewsDataTable'
import { useMyReviews } from '../../Contexts/MyReviewsContext'

export const MyReviewsPage = () => {
  const L = useLocalizedStrings()
  const { stats, statsLoading, getMyReviewsStats, getMyReviews, page, limit, search, sorting, filters } = useMyReviews()

  // Fetch stats on mount and poll every 10 seconds
  useEffect(() => {
    getMyReviewsStats()

    const statsInterval = setInterval(() => {
      getMyReviewsStats(true) // silent refresh
    }, 10000)

    return () => clearInterval(statsInterval)
  }, [getMyReviewsStats])

  // Poll reviews data every 10 seconds
  useEffect(() => {
    const reviewsInterval = setInterval(() => {
      getMyReviews(page, limit, search, sorting, filters, true) // silent refresh
    }, 10000)

    return () => clearInterval(reviewsInterval)
  }, [getMyReviews, page, limit, search, sorting, filters])

  const breadcrumbs: BreadcrumbProps['items'] = [
    {
      label: L.admin_panel.nav.reviews,
      href: '/admin-panel/reviews/queues'
    },
    {
      label: L.admin_panel.nav.my_reviews
    }
  ]

  return (
    <AdminPanelPage
      title={L.admin_panel.nav.my_reviews}
      breadcrumbs={breadcrumbs}
    >
      <div className="flex flex-col gap-2 sm:gap-4 w-full">
        {/* Stats Cards */}
        <div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
          <NumberDisplay
            loading={statsLoading}
            className="sm:max-w-64 min-w-64"
            title={L.admin_panel.reviews.claimed_applicants}
            value={stats?.claimed ?? 0}
            iconName="ClockIcon"
            iconColor="blue"
          />
          <NumberDisplay
            loading={statsLoading}
            className="sm:max-w-64 min-w-64"
            title={L.admin_panel.reviews.in_review}
            value={stats?.in_progress ?? 0}
            iconName="EyeIcon"
            iconColor="blue"
          />
          <NumberDisplay
            loading={statsLoading}
            className="sm:max-w-64 min-w-64"
            title={L.admin_panel.reviews.completed}
            value={stats?.completed ?? 0}
            iconName="CheckCircleIcon"
            iconColor="green"
          />
        </div>

        {/* Reviews Data Table */}
        <div>
          <MyReviewsDataTable />
        </div>
      </div>
    </AdminPanelPage>
  )
}
